module.exports = __webpack_public_path__ + "img/6.298d72d3.jpg";